import { defineStore } from 'pinia';

import { ApiGetPermissionsBoard, ApiPermissionsCurrent } from '@/api/team.js';

export const permissionStore = defineStore({
  id: 'permission',
  state: () => {
    return {
      permission: [],
      permissionBoard: []
    };
  },
  actions: {
    async getPermissionBoard() {
      const permissionsData = await ApiGetPermissionsBoard();
      if (!permissionsData.msg) {
        this.permissionBoard = permissionsData.contentTypeDetails;
      }
    },
    async getOwnPermission() {
      const permissionsCurrentData = await ApiPermissionsCurrent();
      if (!permissionsCurrentData.msg) {
        const permissionFormat = {};
        this.permissionBoard.forEach((contentType) => {
          permissionFormat[contentType.id] = {};
          contentType.actions.forEach((actions) => {
            permissionFormat[contentType.id][actions] = false;
          });
        });

        permissionsCurrentData.results.forEach((item) => {
          if (!permissionFormat[item.contentType]) {
            permissionFormat[item.contentType] = {};
          }
          permissionFormat[item.contentType][item.action] = item.enabled || false;
        });
        this.permission = permissionFormat;
      }
    },
    setPermission(permissions) {
      this.permission = permissions;
    }
  }
});
